import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["appId", "accountId", "providerKey", "registry", "children", "onComplete", "onCancel", "portalId", "appName", "oAuthScopes", "mcpParams", "incremental", "config", "modalSettings", "use", "size"];
import { LoadingButton } from 'foundations-components/transitional/components/LoadingButton';
import { defaultRegistry, useResolvedProvider } from './registry';
import { jsx as _jsx } from "react/jsx-runtime";
export const ReconnectAccount = _ref => {
  let {
      appId,
      accountId,
      providerKey,
      registry = defaultRegistry,
      children,
      onComplete,
      onCancel,
      portalId,
      appName,
      oAuthScopes,
      mcpParams,
      incremental,
      config,
      modalSettings,
      use,
      size
    } = _ref,
    buttonProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const {
    components,
    isLoading
  } = useResolvedProvider(appId, providerKey, registry);
  if (isLoading) {
    return /*#__PURE__*/_jsx(LoadingButton, {
      use: use,
      size: size,
      disabled: true,
      loading: true,
      children: children
    });
  }
  if (!components) {
    throw new Error(providerKey ? `[ReconnectAccount] No auth provider found for appId: ${appId} with providerKey: "${providerKey}"` : `[ReconnectAccount] No auth provider found for appId: ${appId}`);
  }
  const {
    Button
  } = components;
  return /*#__PURE__*/_jsx(Button, Object.assign({}, buttonProps, {
    use: use,
    size: size,
    appId: appId,
    accountId: accountId,
    portalId: portalId,
    appName: appName,
    oAuthScopes: oAuthScopes,
    mcpParams: mcpParams,
    incremental: incremental,
    config: config,
    modalSettings: modalSettings,
    onComplete: onComplete,
    onCancel: onCancel,
    children: children
  }));
};
ReconnectAccount.displayName = 'ReconnectAccount';